import { useAsyncData } from '#imports'
import { ref } from 'vue'

import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'
import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'

import { useUrlParams } from '~/scopes/product/composables/useUrlParams'

import { useRequests } from './useRequests'

function useReviewsAIExperimentIsEnabled() {
  const experiments = useExperiments()

  return experiments['experiment.reviewsAiSummary'] === 'enabled'
}
export function useReviewsAISummary() {
  const requests = useRequests()
  const { productId } = useUrlParams()

  const $httpFetch = useHttpFetch()

  const isExperimentEnabled = useReviewsAIExperimentIsEnabled()

  const hasReviewsAISummary =
    requests &&
    'hasAIReviewsSummary' in requests &&
    requests.hasAIReviewsSummary &&
    isExperimentEnabled

  if (!hasReviewsAISummary)
    return { data: ref(), error: ref(), pending: ref(false), isEnabled: false }

  const { data, pending } = useAsyncData(
    `reviews-ai-summary-${productId}`,
    async () => {
      return $httpFetch('/reviews/v1/products/:uuid/reviews-ai-summary', {
        pathParams: { uuid: productId },
      })
    },
    {
      lazy: true,
      server: false,
    },
  )

  return {
    data,
    pending,
    isEnabled: true,
  }
}
